import React from "react";
import {Route, RouteProps, Redirect} from "react-router-dom";
import _ from "lodash";

import {useSelector} from "react-redux";

const PrivateRoute: React.FC<RouteProps> = (props) => {
    const tokenSelector = (state: any) => state.auth.token;
    const token = useSelector(tokenSelector);
    const nowLogin = !!token;

    const rest = _.omit(props, ["component"]);
    return (
        <Route
            {...rest}
            render={(innerProps) =>
                nowLogin ? (
                    <Route {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: {from: innerProps.location},
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
